module.exports = __webpack_public_path__ + "static/media/instructor-customer-preferences.2fa1bd33.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/instructor-customer-preferences.png
// module id = 2584
// module chunks = 0